import { render, staticRenderFns } from "./accountSettings.vue?vue&type=template&id=9b13fe2e&scoped=true&"
import script from "./accountSettings.vue?vue&type=script&lang=js&"
export * from "./accountSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b13fe2e",
  null
  
)

export default component.exports